import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EmployeeExaminationFilterInput } from "../../core/interfaces/employee-examination-input";

@Injectable()
export class SStatsCardEmployeeExaminationService {

    private readonly endpointQuery = "hcm/analytics_sst/queries";

    constructor(private readonly httpClient: HttpClient) {}

    totalizerEmployeeExaminationCardsCount(filter: EmployeeExaminationFilterInput) {
        return this.httpClient.post(`${this.endpointQuery}/employeeExaminationTotalizerQuery`, {
            ...filter
        });
    }
}
